import { Controller } from 'stimulus'

/**
 * @namespace RadioButtonGroupWithMenu
 */
export default class extends Controller {
  static get targets() {
    return [
      'suggestedOption',
      'remainingOption',
      'menuButton',
      'menuButtonLabelVisible',
      'menuButtonLabelHidden',
      'hiddenSelect'
    ]
  }

  /**
     * Change the label on the menu toggle button
     * @param {string} visibleLabel - The label that appears in the UI
     * @param {string} screenReaderLabel - The text that a screen reader announces to users
     */
  changeMenuButtonAttributes(visibleLabel, screenReaderLabel) {
    $(this.menuButtonLabelVisibleTarget).text(visibleLabel)
    $(this.menuButtonLabelHiddenTarget).text(screenReaderLabel)
    $(this.menuButtonTarget).attr('aria-pressed', visibleLabel !== 'More')
  }

  /**
     * Determine how to update the button, based on
     * which list the option comes from
     * (suggested options list or remaining options list)
     * @param {HTMLButtonElement} target
     */
  updateMenuButton(target) {
    if (this.suggestedOptionTargets.includes(target)) {
      this.changeMenuButtonAttributes('More', 'Action Type options available.')
    } else {
      const label = $(target).text().trim()
      this.changeMenuButtonAttributes(label, 'selected. More Action Type options available.')
      $(this.menuButtonTarget).focus()
    }
  }

  /**
     * Clear any pre-existing selections and update
     * radio buttons, hidden select value, and menu button
     * when a (new) option is selected
     * @param {(MouseEvent|KeyboardEvent)} event
     */
  selectOption(event) {
    $(this.suggestedOptionTargets).attr('aria-checked', 'false')
    $(this.remainingOptionTargets).attr('aria-checked', 'false')
    $(event.target).attr('aria-checked', 'true')
    const value = $(event.target).data('value')
    $(this.hiddenSelectTarget).val(value)
    this.updateMenuButton(event.target)
  }
}
